export enum SlydeTypeOption {
  CenteredImageBackground = 0,
  SplitImageLeft = 1,
  SplitImageRight = 2
}

export enum MediaTypeOption {
  Image = 0,
  Video = 1
}

export enum Colors {
  DarkTeal = "#172C36",
  DarkBlue = "#0D3166",
  Blue = "#0067A5",
  LightBlue = "#26BFF0",
  Teal = "#007C89",
  LightTeal = "#5EC5BE",
  Green = "#009457",
  Purple = "#8C2A90",
  Orange = "#F68E1E",
  LightOrange = "#FCB814",
  Lime = "#D6DF25",
  White = "#FFFFFF"
}

export interface ISlide {
  Key: String,
  Header: String,
  Paragraph: String,
  ButtonLabel: String,
  ButtonUrl: String,
  ImageId: Number,
  VideoId: Number,
  ImageUrl: String,
  VideoUrl: String,
  SlideType: SlydeTypeOption,
  MediaType: MediaTypeOption,
  BackgroundColor: String
};

export interface IHeroCarouselProps {
  slides: ISlide[]
}

export interface IHeroCarouselSlideProps extends ISlide {};

export interface IHeroCarouselPlayPauseProps {
  isPause: boolean;
}
